import { payloads, nationalAverages } from './sp-tagular';
import setCorrelationId from '../utils/setCorrelationId';
import setHostedFallback from '../utils/setHostedFallback';

(() => {
  // Set up auto tagular events
  const ids = Object.keys(payloads);

  // Constant tracking
  ids.forEach((selector) => {
    const el = document.querySelector(`#${selector}`);
    const els = document.querySelectorAll(`.${selector}`);
    if (el) {
      const {
        type, actionOutcome, webElement, event
      } = payloads[selector];
      el.addEventListener('click', () => {
        window.tagular('beam', event, {
          '@type': type,
          webElement,
          actionOutcome,
        });
      });
    } else if (els?.length) {
      els.forEach((classEl) => {
        const {
          type, actionOutcome, webElement, event
        } = payloads[selector];
        classEl.addEventListener('click', () => {
          window.tagular('beam', event, {
            '@type': type,
            webElement: {
              ...webElement,
              text: classEl.innerText ? classEl.innerText : '',
            },
            actionOutcome,
          });
        });
      });
    }
  });

  // National averages
  document.querySelectorAll('.national-average').forEach((el) => {
    const { type, webElement, event } =
      nationalAverages[el.attributes.buttontitle.value];
    el.addEventListener('click', () => {
      /* This conditional exists because closing the modal would trigger
      the listener again due to shadow dom behavior. Also, this might look
      wrong at first, but the open attribute is added before this click event fires
      */
      if (el.attributes.open) {
        window.tagular('beam', event, {
          '@type': type,
          webElement,
          actionOutcome: 'Trigger Modal',
        });
      }
    });
  });

  // Recommender Tool Cards
  const recommenderCardTracking = (selector) => {
    document.querySelectorAll(selector).forEach((el, index) => {
      const elementPayload = {
        name: 'school-profile-card',
        location: 'school-profile-page',
        position: `${index + 1}`,
        elementType: 'carousel',
        text: el.querySelector('.js-ranking-text')
          ? `${el.querySelector('h3').innerText} ${
            el.querySelector('.js-ranking-text').innerText
          }`
          : el.querySelector('h3').innerText,
        htmlId: el.getAttribute('href').replace('/schools/', ''),
      };

      el.addEventListener('click', () => {
        window.tagular('beam', {
          '@type': 'redventures.usertracking.v3.ElementClicked',
          webElement: elementPayload,
          correlationId: setCorrelationId(),
          actionOutcome: 'Internal Link',
        });
      });

      let cardViewed = false;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting && !cardViewed) {
              window.tagular('beam', 'ElementViewed', {
                '@type': 'redventures.usertracking.v3.ElementViewed',
                webElement: elementPayload,
              });
              cardViewed = true;
            }
          },
          {
            threshold: 0.5,
          }
        );
        observer.observe(el);
      }
    });
  };

  recommenderCardTracking('.js-recommended-card');
  recommenderCardTracking('.js-recommended-card-mobile');

  // Admissions breakdown + tagular
  const admissions = document.querySelector('#admissions');
  const insights = document.querySelector('#insights');
  if (admissions && insights) {
    admissions.addEventListener('click', (e) => {
      if (e.target.dataset.admission) {
        window.tagular('beam', 'ElementClicked', {
          '@type': 'redventures.usertracking.v3.ElementClicked',
          webElement: {
            name: 'revealInfo',
            location: 'admissions-breakdown',
            position: '2',
            elementType: 'metric',
            text: e.target.firstChild.nextSibling.innerText,
          },
          actionOutcome: 'Change visual',
        });
        admissions.querySelector('.bg-insight').classList.toggle('bg-insight');
        e.target.classList.toggle('bg-insight');
        const activeEl = insights.querySelector('.insight-active');
        activeEl.classList.toggle('hidden');
        activeEl.classList.toggle('insight-active');
        const toggleEl = insights.querySelector(
          `[data-insight="${e.target.dataset.admission}"`
        );
        toggleEl.classList.toggle('hidden');
        toggleEl.classList.toggle('insight-active');
      }
    });
  }

  // const scrollCtaContainer = document.querySelector('#scrollCtaContainer');
  const scrollCta = document.querySelector('#freeProfileScrollCta');
  const freeMobileCta = document.querySelector('#freeProfileCta');
  const freeDesktopCta = document.querySelector('#freeProfileCtaDesktop');
  const hlfLink = document.querySelector('.js-hlf-link');

  // CTAs
  // Dynamic CTA outbound url
  const outboundUrl = `https://college.bestcolleges.com/app/experience/?publisher=bestcolleges.com&url=${window.location.href}&trafficSource=organic`;
  if (freeDesktopCta && !hlfLink) {
    freeDesktopCta.setAttribute('href', outboundUrl);
  }
  if (freeMobileCta && !hlfLink) {
    freeMobileCta.setAttribute('href', outboundUrl);
  }
  if (scrollCta && !hlfLink) {
    scrollCta.setAttribute('href', outboundUrl);
  }
  const idToken = window?.HE?.publisher?.identityToken;
  // HLF CTA url with studymatch fallback
  if (hlfLink && idToken) {
    const { cap, program } = hlfLink.dataset;
    const config = {
      idToken,
      cap,
      program,
      fallbackUrl: outboundUrl,
    };
    setHostedFallback(hlfLink, config);
  }

  // Read More in blurb
  const readMoreButton = document.querySelector('#readMore');
  const readMoreP = document.querySelector('.read-more');
  if (readMoreButton) {
    readMoreButton.addEventListener('click', () => {
      readMoreP.classList.toggle('expanded');
      const action =
        readMoreButton.innerText === 'read more' ? 'expand' : 'collapse';
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          name: action,
          location: 'school-description',
          position: '1',
          elementType: 'button',
          text: readMoreButton.innerText,
        },
        actionOutcome: `${action} description`,
      });
      readMoreButton.innerText =
        readMoreButton.innerText === 'read more' ? 'read less' : 'read more';
    });
  }

  // Show More in Rankings
  const showMoreButton = document.querySelector('#rankingsShowMore');
  const showLessButton = document.querySelector('#rankingsShowLess');
  const rankingToggles = document.querySelectorAll('.rankings-toggle');
  const rankingsList = document.querySelector('.rankings-list');
  showMoreButton?.addEventListener('click', () => {
    rankingsList.classList.remove('rankings-list--collapsed');
    rankingToggles.forEach((button) => {
      button.classList.toggle('hidden');
    });
  });
  showLessButton?.addEventListener('click', () => {
    rankingsList.classList.add('rankings-list--collapsed');
    rankingToggles.forEach((button) => {
      button.classList.toggle('hidden');
    });
  });

  // application consideration tabs
  const admissionsTabs = document.querySelectorAll('.js-admissions-tab');
  const admissionsPanels = document.querySelectorAll('.js-admissions-panel');

  admissionsTabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      for (let i = 0; i < admissionsTabs.length; i += 1) {
        if (tab === admissionsTabs[i]) {
          admissionsTabs[i].classList.add('active');
        } else {
          admissionsTabs[i].classList.remove('active');
        }
      }
      admissionsPanels.forEach((panel) => {
        if (panel.id === e.target.dataset.target) {
          panel.classList.remove('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    });
  });
})();
